import BuyBillingAsset from './BuyBillingAsset';

export default BuyBillingAsset;
